import { Head, Link, useForm } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface Todo {
  id: number
  title: string
}
interface Props {
  todo: Todo
  reply: { notes: string }
  errors?: Record<string, string[]>
}

export default function New({ todo, errors }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Marketing Todos", href: "/marketing_todos" },
    { title: todo.title, href: `/marketing_todos/${todo.id}` },
    { title: "Replies", href: `/marketing_todos/${todo.id}/replies` },
    { title: "New", href: `/marketing_todos/${todo.id}/replies/new` },
  ]
  const { data, setData, post, processing, transform } = useForm({ notes: "" })

  transform((data) => ({ marketing_todo_reply: data }))

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post(`/marketing_todos/${todo.id}/replies`)
  }
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Add Reply" />
      <div className="p-6">
        <h1 className="mb-4 text-2xl font-semibold">
          Add Reply to {todo.title}
        </h1>
        <form onSubmit={handleSubmit} className="max-w-xl space-y-4">
          <div>
            <label className="block font-medium">Notes</label>
            <textarea
              value={data.notes}
              onChange={(e) => setData("notes", e.target.value)}
              className="w-full rounded border px-3 py-2"
              rows={6}
            />
            {errors?.notes && (
              <p className="text-hpi-red text-sm">{errors.notes.join(", ")}</p>
            )}
          </div>
          <div className="flex gap-4">
            <button
              type="submit"
              disabled={processing}
              className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white disabled:opacity-50"
            >
              Add Reply
            </button>
            <Link
              href={`/marketing_todos/${todo.id}`}
              className="hover:bg-hpi-pale-gray rounded border px-4 py-2"
            >
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </AppLayout>
  )
}
